const imageContext = require.context('@/assets/image/match', true, /\.(png|jpe?g|gif|svg|webp|mp4)$/i)

export function getImg(path) {
  return imageContext(`./${path.replace(/^match\//, '')}`)
}
